import * as React from 'react';
import { PlayerState } from '../player/types';
var context = React.createContext({
    state: PlayerState.None
});
export var PlayerContextProvider = context.Provider;
export var PlayerContextConsumer = context.Consumer;
export var playerContext = context;
//# sourceMappingURL=player.js.map